module.exports = __webpack_public_path__ + "img/phone.3b7cbb16.png";